import { createRoot } from "react-dom/client";
import App from "./App";
import { initializeSentry } from "./sentry";

initializeSentry();

function initializeWidget() {
  const widgetRoot = document.createElement("div");
  widgetRoot.id = "popup-widget-root";
  widgetRoot.style.position = "relative";
  widgetRoot.style.zIndex = "9999";
  document.body.appendChild(widgetRoot);

  // The store (src/redux/store.ts) is a module singleton; no provider needed.
  createRoot(widgetRoot).render(<App />);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeWidget);
} else {
  initializeWidget();
}
